import { combineReducers } from 'redux';
import row from './row-reducers';
import { validateRow } from '../state-validator';
import options from './container-options-reducers';
import { UUID } from '../util';
import undoable, { distinctState } from 'redux-undo'

import {
  SET_ACTIVE_DEVICE,

  REMOVE,
  HIGHLIGHT,
  PREVIEW,

  INSERT_ROW,

  RESIZE_COLUMN,
  RESIZE_COLUMN_FINISHED,
  SET_ROW_NUMBER_OF_COLUMNS,
  SET_ROW_PADDING,
  SET_ROW_MARGIN,

  SET_DROP_PREVIEW_INDEX_PATH,
  RESET_DROP_PREVIEW_INDEX_PATH,
  INSERT_ELEMENT_INTO_COLUMN,
  REMOVE_ELEMENT_FROM_COLUMN,
  REINDEX_ELEMENTS,

  SET_COLUMN_BACKGROUND_COLOR,
  SET_COLUMN_PADDING,

  SET_BUTTON_ELEMENT_TEXT,
  SET_BUTTON_ELEMENT_URL,
  SET_BUTTON_ELEMENT_TARGET,
  SET_BUTTON_ELEMENT_CORNER_RADIUS,
  SET_BUTTON_ELEMENT_WIDTH,
  SET_BUTTON_ELEMENT_PADDING,

  SET_IMAGE_ELEMENT_FILE_INFO,
  SET_IMAGE_ELEMENT_URL,
  SET_IMAGE_ELEMENT_WIDTH,
  SET_IMAGE_ELEMENT_HEIGHT,
  SET_IMAGE_ELEMENT_ALIGN,

  SET_SEARCH_TEXT_WIDTH,
  SET_SEARCH_VERTICAL_PADDING,
  SET_SEARCH_TEXT_BG_COLOR,
  SET_SEARCH_TEXT_COLOR,
  SET_SEARCH_BORDER_COLOR,
  SET_SEARCH_BUTTON_STYLE,
  SET_SEARCH_BUTTON_BG_COLOR,
  SET_SEARCH_BUTTON_TEXT_ICON_COLOR,
  SET_SEARCH_BUTTON_CONTENT,
  SET_SEARCH_ICON_COLOR,
  SET_SEARCH_PLACEHOLDER_TEXT,

  LANGUAGE_SELECTOR_SELECT,
  LANGUAGE_SELECTOR_MOVE_UP,
  LANGUAGE_SELECTOR_MOVE_DOWN,
  LANGUAGE_SELECTOR_REMOVE,
  LANGUAGE_SELECTOR_SAVE,
  LANGUAGE_SELECTOR_ENABLE_FLAG,

  SET_SHOPPING_ICON_ELEMENT_FILE_INFO,
  SET_SHOPPING_ICON_ELEMENT_ICON_SIZE,
  SET_SHOPPING_ICON_ELEMENT_ICON_COLOR,
  SET_SHOPPING_ICON_ELEMENT_TEXT_COLOR,

  SET_NAVIGATION_MENU,
  SET_NAVIGATION_STYLE,
  SET_NAVIGATION_TEXT_COLOR,
  SET_NAVIGATION_TEXT_HOVER_COLOR,
  SET_NAVIGATION_ACCENT_COLOR,

  SOCIAL_MEDIA_SELECT,
  SOCIAL_MEDIA_MOVE_UP,
  SOCIAL_MEDIA_MOVE_DOWN,
  SOCIAL_MEDIA_REMOVE,
  SOCIAL_MEDIA_SAVE,
  SOCIAL_MEDIA_CHANGE_COLOR,
  SOCIAL_MEDIA_CHANGE_HOVER_COLOR,
  SOCIAL_MEDIA_CHANGE_ICON_SIZE,

  DIVIDER_CHANGE_COLOR,
  DIVIDER_CHANGE_WIDTH,
  DIVIDER_CHANGE_VERTICAL_PADDING,

  TEXTBOX_CHANGE_TEXT,

  SET_LOGO_ELEMENT_WIDTH,
  SET_LOGO_ELEMENT_HEIGHT,
  SET_LOGO_ELEMENT_LINK_HOMEPAGE,
  SET_LOGO_ELEMENT_MARGIN,
  SET_LOGO_ELEMENT_PADDING,
} from '../actions/action-names';

const id = (state = '', action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const highlightedId = (state = '', action) => {
  switch (action.type) {
    case HIGHLIGHT:
      return action.id;

    case REMOVE:
      return '';

    default:
      return state;
  }
};

const category = (state = 'UNKNOWN', action) => {
  return state;
};

const rows = (state = [], action) => {
  switch (action.type) {
    case INSERT_ELEMENT_INTO_COLUMN:
      return state.map(r => row(r, action));

    case RESIZE_COLUMN:
    case RESIZE_COLUMN_FINISHED:
    case REMOVE_ELEMENT_FROM_COLUMN:
    case REINDEX_ELEMENTS:
    case SET_ROW_NUMBER_OF_COLUMNS:
    case SET_ROW_PADDING:
    case SET_ROW_MARGIN:
    case SET_COLUMN_BACKGROUND_COLOR:
    case SET_COLUMN_PADDING:
      return state.map(r => r.id === action.rowId ? row(r, action) : r);

    case INSERT_ROW:
      return [ ...state, row(validateRow(action.row), action) ];

    case REMOVE:
      return state
        .filter(r => r.id !== action.highlightedId)
        .map(r => row(r, action));

    case SET_BUTTON_ELEMENT_TEXT:
    case SET_BUTTON_ELEMENT_URL:
    case SET_BUTTON_ELEMENT_TARGET:
    case SET_BUTTON_ELEMENT_CORNER_RADIUS:
    case SET_BUTTON_ELEMENT_WIDTH:
    case SET_BUTTON_ELEMENT_PADDING:

    case SET_IMAGE_ELEMENT_FILE_INFO:
    case SET_IMAGE_ELEMENT_URL:
    case SET_IMAGE_ELEMENT_WIDTH:
    case SET_IMAGE_ELEMENT_HEIGHT:
    case SET_IMAGE_ELEMENT_ALIGN:

    case SET_SEARCH_TEXT_WIDTH:
    case SET_SEARCH_VERTICAL_PADDING:
    case SET_SEARCH_TEXT_BG_COLOR:
    case SET_SEARCH_TEXT_COLOR:
    case SET_SEARCH_BORDER_COLOR:
    case SET_SEARCH_BUTTON_STYLE:
    case SET_SEARCH_BUTTON_BG_COLOR:
    case SET_SEARCH_BUTTON_TEXT_ICON_COLOR:
    case SET_SEARCH_BUTTON_CONTENT:
    case SET_SEARCH_ICON_COLOR:
    case SET_SEARCH_PLACEHOLDER_TEXT:

    case LANGUAGE_SELECTOR_SELECT:
    case LANGUAGE_SELECTOR_MOVE_UP:
    case LANGUAGE_SELECTOR_MOVE_DOWN:
    case LANGUAGE_SELECTOR_REMOVE:
    case LANGUAGE_SELECTOR_SAVE:
    case LANGUAGE_SELECTOR_ENABLE_FLAG:

    case SET_SHOPPING_ICON_ELEMENT_FILE_INFO:
    case SET_SHOPPING_ICON_ELEMENT_ICON_SIZE:
    case SET_SHOPPING_ICON_ELEMENT_ICON_COLOR:
    case SET_SHOPPING_ICON_ELEMENT_TEXT_COLOR:

    case SET_NAVIGATION_MENU:
    case SET_NAVIGATION_STYLE:
    case SET_NAVIGATION_TEXT_COLOR:
    case SET_NAVIGATION_TEXT_HOVER_COLOR:
    case SET_NAVIGATION_ACCENT_COLOR:

    case SOCIAL_MEDIA_SELECT:
    case SOCIAL_MEDIA_MOVE_UP:
    case SOCIAL_MEDIA_MOVE_DOWN:
    case SOCIAL_MEDIA_REMOVE:
    case SOCIAL_MEDIA_SAVE:
    case SOCIAL_MEDIA_CHANGE_COLOR:
    case SOCIAL_MEDIA_CHANGE_HOVER_COLOR:
    case SOCIAL_MEDIA_CHANGE_ICON_SIZE:

    case DIVIDER_CHANGE_COLOR:
    case DIVIDER_CHANGE_WIDTH:
    case DIVIDER_CHANGE_VERTICAL_PADDING:

    case SET_LOGO_ELEMENT_WIDTH:
    case SET_LOGO_ELEMENT_HEIGHT:
    case SET_LOGO_ELEMENT_LINK_HOMEPAGE:
    case SET_LOGO_ELEMENT_MARGIN:
    case SET_LOGO_ELEMENT_PADDING:

    case TEXTBOX_CHANGE_TEXT:

    case SET_SEARCH_TEXT_WIDTH:
    case SET_SEARCH_VERTICAL_PADDING:
    case SET_SEARCH_TEXT_BG_COLOR:
    case SET_SEARCH_TEXT_COLOR:
    case SET_SEARCH_BORDER_COLOR:
    case SET_SEARCH_BUTTON_STYLE:
    case SET_SEARCH_BUTTON_BG_COLOR:
    case SET_SEARCH_BUTTON_TEXT_ICON_COLOR:
    case SET_SEARCH_BUTTON_CONTENT:
    case SET_SEARCH_ICON_COLOR:
    case SET_SEARCH_PLACEHOLDER_TEXT:
      return state.map(r => row(r, action));

    default:
      return state;
  }
};

const container = combineReducers({
  id,
  highlightedId,
  category,
  rows,
  options
});

const preserveHighlightedId = (reducer) => {
  return (state, action) => {
    const newState = reducer(state, action);

    switch (action.type) {
      case HIGHLIGHT:
      case REMOVE:
        return newState;
    }

    return {
      ...newState,
      present: {
        ...newState.present,
        highlightedId: state.present.highlightedId
      }
    };
  };
};

const undoableContainer = (() => {
  let resizing = false;

  return undoable(container, {
    filter(action, currentState, previousHistory) {
      if (currentState === previousHistory.present) {
        return false;
      }

      switch (action.type) {
        case SET_DROP_PREVIEW_INDEX_PATH:
        case RESET_DROP_PREVIEW_INDEX_PATH:
        case SET_ACTIVE_DEVICE:
        case HIGHLIGHT:
        case PREVIEW:
          return false;

        case RESIZE_COLUMN:
          let isFirstResize = !resizing;
          resizing = true;
          return isFirstResize;

        case RESIZE_COLUMN_FINISHED:
          resizing = false;
          return false;
      }

      if (action.type === INSERT_ELEMENT_INTO_COLUMN) {
        if (action.device !== action.reducerForDevice) {
          return false;
        }
      }

      return true;
    }
  });
})();

export default preserveHighlightedId(undoableContainer);



// WEBPACK FOOTER //
// ./app/header-builder/reducers/container-reducers.js